import request from '@/utils/request'

// 報告書一括アップロード
export function bunchUpload(data) {
  return request({
    url: '/api/reportFileRc/bunchUpload',
    method: 'post',
    data,
    headers: { 'Content-Type': 'multipart/form-data' },
  })
}

// 報告書雛形ダウンロード
export function exportTemplateZip(data) {
  return request({
    url: '/api/workingPlanAndResult/exportTemplateZip',
    method: 'post',
    data,
    responseType: 'blob',
  })
}
